import { render, staticRenderFns } from "./PercentBars.vue?vue&type=template&id=481a316e&scoped=true&"
import script from "./PercentBars.vue?vue&type=script&lang=js&"
export * from "./PercentBars.vue?vue&type=script&lang=js&"
import style0 from "./PercentBars.vue?vue&type=style&index=0&id=481a316e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a316e",
  null
  
)

export default component.exports